module.exports = __webpack_public_path__ + "img/report-2.4390c60b.png";